<template>
	<svg
		width="200"
		height="100"
		viewBox="0 0 200 100"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="200" height="50" fill="#015BBB" />
		<rect y="50" width="200" height="50" fill="#FED500" />
	</svg>
</template>

<script>
export default {
	name: "Ukraine",
};
</script>
